export default __webpack_public_path__ + "static/media/icon_urheilutoiminta_summary.095570fc.svg";